module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/059-gabon-9558c745e0987e02bd1746e3a13dbb4a.svg";